var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrHiring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.002 512.002",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffce47"
    },
    d: "M219.217,207.04h47.611c31.011,0,56.152,25.139,56.152,56.152v82.999H149.117v-82.999 c0-31.011,25.139-56.152,56.152-56.152h47.611"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c5050"
    },
    d: "M298.245,198.999c6.543-9.139,10.412-20.318,10.412-32.391v-38.011 c0-8.469-6.867-15.334-15.334-15.334s-15.334,6.865-15.334,15.334v38.011c0,13.775-11.153,24.986-24.902,25.098H219.01 c-13.749-0.113-24.902-11.323-24.902-25.098v-38.011c0-13.844,11.263-25.109,25.109-25.109h33.664 c8.468,0,15.334-6.865,15.334-15.334s-6.867-15.334-15.334-15.334h-33.664c-30.756,0-55.778,25.021-55.778,55.778v38.011 c0,12.073,3.867,23.252,10.412,32.391c-23.707,11.65-40.067,36.044-40.067,64.193v82.999c0,8.469,6.865,15.335,15.334,15.335 h173.862c8.468,0,15.335-6.865,15.335-15.335v-82.999C338.314,235.041,321.953,210.649,298.245,198.999z M307.645,330.857H164.451 v-67.665c0-22.506,18.309-40.817,40.817-40.817h13.534c0.138,0.002,0.274,0.011,0.413,0.011h1.498v62.744 c0,8.469,6.865,15.335,15.334,15.335c8.469,0,15.334-6.865,15.334-15.335v-62.744h1.497c0.138,0,0.274-0.009,0.412-0.011h13.534 c22.508,0,40.817,18.309,40.817,40.817v67.665H307.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c5050"
    },
    d: "M234.702,469.4c-60.13,0-120.259-22.888-166.034-68.663c-91.551-91.551-91.551-240.518,0-332.07 s240.518-91.551,332.07,0c5.988,5.988,5.988,15.698,0,21.686c-5.99,5.988-15.696,5.988-21.688,0 c-38.557-38.557-89.82-59.791-144.348-59.791S128.909,51.797,90.353,90.353c-79.594,79.594-79.594,209.103,0,288.698 c38.557,38.557,89.82,59.791,144.348,59.791s105.791-21.234,144.348-59.791c5.99-5.988,15.696-5.988,21.688,0 c5.988,5.988,5.988,15.698,0,21.686C354.961,446.513,294.831,469.4,234.702,469.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c5050"
    },
    d: "M75.405,242.702c-0.238,0-0.474-0.005-0.713-0.015c-8.46-0.386-15.005-7.56-14.618-16.02 c1.997-43.625,20.114-84.669,51.016-115.573c5.988-5.988,15.698-5.99,21.686,0c5.988,5.99,5.99,15.698,0,21.686 c-25.481,25.483-40.42,59.323-42.066,95.29C90.337,236.289,83.551,242.702,75.405,242.702z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 427.216,
    y: 415.499,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1092.5405 452.5643)",
    style: {
      fill: "#ffce47"
    },
    width: 50.649,
    height: 74.111
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c5050"
    },
    d: "M507.511,450.006l-52.409-52.409c-5.99-5.987-15.696-5.987-21.688,0l-7.066,7.066l-25.613-25.615 c-2.995-2.995-6.919-4.491-10.843-4.491c-0.071,0-0.141,0.009-0.213,0.011c-0.419,0.006-0.839,0.02-1.256,0.06 c-2.71,0.259-5.355,1.254-7.643,2.952c-0.601,0.446-1.187,0.923-1.731,1.469c-0.002,0.002-0.003,0.005-0.006,0.006 c-79.594,79.589-209.099,79.584-288.69-0.006c-79.594-79.594-79.594-209.103,0-288.698c79.592-79.592,209.101-79.594,288.696,0 c57.464,57.464,75.387,143.477,45.66,219.128c-3.098,7.882,0.782,16.784,8.664,19.88c7.885,3.099,16.784-0.782,19.881-8.664 c34.188-87.009,13.574-185.938-52.519-252.031c-91.551-91.551-240.518-91.551-332.07,0s-91.551,240.518,0,332.07 c45.776,45.776,105.905,68.663,166.034,68.663c55.344,0,110.677-19.406,154.828-58.184l15.134,15.135l-7.066,7.066 c-5.988,5.988-5.988,15.698,0,21.688l52.409,52.409c2.877,2.875,6.776,4.491,10.843,4.491c4.067,0,7.966-1.616,10.843-4.491 l35.818-35.818c2.875-2.875,4.491-6.776,4.491-10.843C512,456.782,510.386,452.881,507.511,450.006z M460.848,474.983 l-30.721-30.723l14.132-14.132l30.721,30.723L460.848,474.983z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrHiring);
export default __webpack_public_path__ + "static/media/hr-hiring.7e856e2889bff6e2556e3bb18cec37e0.svg";
export { ForwardRef as ReactComponent };